import { fromJS } from 'immutable';
import { LOAD_ENTITIES_UPDATED_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  entitiesUpdated: null,
});

const metaInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_ENTITIES_UPDATED_SUCCESS: {
      return state.set('entitiesUpdated', { ...action.payload });
    }

    default: {
      return state;
    }
  }
};

export default metaInformationReducer;
